import RedeemOutlined from '@mui/icons-material/RedeemOutlined';
import Storefront from '@mui/icons-material/Storefront';
import * as React from 'react';

import { MARKETPLACE_SOURCE_LABEL } from '../../constants/marketplace';
import { useCurrency } from '../../contexts/CurrencyProvider';
import { IMarketplaceSendItem } from '../../types/marketplace';
import variables from '../../_variables.scss';
import CampaignViewItem from '../CampaignViewItem/CampaignViewItem';
import ItemQuantity from '../ItemQuantity/ItemQuantity';

import styles from './MarketplaceSendItemView.module.scss';

interface IProps {
  item: IMarketplaceSendItem;
  showQuantity?: boolean;
  className?: string;
  iconClassName?: string;
  defaultView?: boolean;
}

const MarketplaceSendItemView: React.FC<IProps> = ({ item, showQuantity, className, iconClassName, defaultView }) => {
  const { getRequiredPriceAndCurrency } = useCurrency();
  const { product_id: productId, name, price, currency, image_url: imageUrl, quantity } = item;

  const displayPrice = React.useMemo(
    () => getRequiredPriceAndCurrency({ price, currency_code: currency }),
    [getRequiredPriceAndCurrency, price, currency],
  );

  return (
    <CampaignViewItem
      name={name}
      price={displayPrice}
      imageUrl={imageUrl}
      className={className}
      iconClassName={iconClassName}
      defaultView={defaultView}
      placeholderIcon={<RedeemOutlined />}
      badge={showQuantity ? <ItemQuantity quantity={quantity} /> : undefined}
      details={
        <div className={styles.details} data-testid={`marketplace-send-item-${productId}`}>
          <span className={styles.source}>
            <Storefront className={styles.sourceIcon} sx={{ fontSize: 14, color: variables.marketplaceAccent }} />
            <span className={styles.sourceLabel}>{MARKETPLACE_SOURCE_LABEL}</span>
          </span>
        </div>
      }
    />
  );
};

export default MarketplaceSendItemView;
